import type { VoidFunctionComponent } from 'react';

import { OrganizationSsoMethod } from '../../../../../../typings/enums';
import Text from '../../../../generic/Text';

import AuthenticationMethodPicker from './AuthenticationMethodPicker';
import GoogleClaimDomain from './Google/ClaimDomain';
import LDAPAuth from './LDAP/Auth';
import LDAPClaimDomain from './LDAP/ClaimDomain';
import SAMLAuth from './SAML/Auth';
import SAMLClaimDomain from './SAML/ClaimDomain';

type Props = {
  method: OrganizationSsoMethod;
  onSelectMethod: (method: OrganizationSsoMethod) => Promise<void>;
};

const SSOConfiguration: VoidFunctionComponent<Props> = ({ method, onSelectMethod }) => {
  return (
    <>
      <Text.H3>SSO Configuration</Text.H3>
      <Text.Paragraph>
        You can configure single sign-on (SSO) with your corporate identity provider. FOSSA supports sign in and account
        provisioning through Google Workspace; SAML identity providers such as Okta, Auth0, and Active Directory
        Federation Service; or LDAP.
      </Text.Paragraph>
      <AuthenticationMethodPicker method={method} onSelectMethod={onSelectMethod} />
      {method === OrganizationSsoMethod.SAML && <SAMLAuth />}
      {method === OrganizationSsoMethod.SAML && <SAMLClaimDomain />}
      {method === OrganizationSsoMethod.LDAP && <LDAPAuth />}
      {method === OrganizationSsoMethod.LDAP && <LDAPClaimDomain />}
      {method === OrganizationSsoMethod.Google && <GoogleClaimDomain />}
    </>
  );
};

export default SSOConfiguration;
